require('@fransat/fransat-assets/src/js/main');
global.jQuery=$;
require('slick-carousel');
require('bootstrap');
require('ekko-lightbox');
//require('./fransat.fonts');
require('./fransat.breakpoints');
require('./fransat.menus');
require('./fransat.forms');
require('./fransat.tabs');
require('./fransat.slick-carousel');
require('./fransat.lightbox');
require('./fransat.pdf-modal');
require('./fransat.divClick.js');
// require('./fransat.tooltips');
import PaymentMethod from "./fransat.paymentMethod";
window.Kernel.registerComponent("PaymentMethod", PaymentMethod);

